<div class="p-1" >
    <mat-card class="p-0">
        <div fxLayout="row wrap" fxLayoutAlign="space-between center" class="w-100 p-2">
            <h2>{{'TOBA LIGHT.banner.bannerList' | translate}}</h2>
            <button mat-raised-button color="primary" (click)="openBannerDialog(null)"> {{'TOBA LIGHT.banner.addBanner' | translate}}</button>
        </div>
        <mat-divider></mat-divider>
        <div class="mat-table admin-table">
            <div class="mat-header-row">
                <div class="mat-header-cell">{{'TOBA LIGHT.banner.title' | translate}}</div>
                <div class="mat-header-cell">{{'TOBA LIGHT.banner.subTitle' | translate}}</div>
                <div class="mat-header-cell">{{'TOBA LIGHT.banner.link' | translate}}</div>
                <div class="mat-header-cell">{{'TOBA LIGHT.banner.image' | translate}}</div>
                <div class="mat-header-cell"></div>
            </div>
            <div *ngFor="let bnr of banners | paginate: { itemsPerPage: count, currentPage: page }" class="mat-row">
                <div class="mat-cell">{{bnr.title}}</div>
                <div class="mat-cell">{{bnr?.subtitle}}</div>
                <div class="mat-cell">{{bnr?.link}}</div>
                <div class="mat-cell">
                    <img width="70" height="70" [src]="bnr?.image[0].preview || bnr?.image">
                </div>
                <div class="mat-cell">
                    <div class="p-1 actions">
                        <button mat-mini-fab color="primary" matTooltip="Edit" (click)="openBannerDialog(bnr)">
                            <mat-icon>edit</mat-icon>
                        </button>
                        <button mat-mini-fab color="warn" matTooltip="Delete" class="mx-1" (click)="remove(bnr)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </mat-card>

    <div *ngIf="banners?.length > 0" fxLayout="row wrap">
        <div fxFlex="100">
            <mat-card class="p-0 text-center">
                <pagination-controls class="product-pagination" autoHide="true" maxSize="5" (pageChange)="onPageChanged($event)"></pagination-controls>
            </mat-card>
        </div>
    </div>
</div>

